/**
 * Toast - Einzelne Toast-Benachrichtigung
 *
 * Zeigt eine kurze, nicht-blockierende Nachricht an.
 * Verschwindet automatisch nach `duration` ms.
 */

import React, { useEffect, useState, memo } from 'react';
import './Toast.css';

const Toast = memo(function Toast({
  id,
  icon,
  message,
  duration = 2000,
  priority = 'normal',
  style = 'default',
  index = 0,
  onDismiss
}) {
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    // Fade in nach kurzem Delay (für Animation)
    const fadeInTimer = requestAnimationFrame(() => setVisible(true));

    // Auto-dismiss nach duration
    const dismissTimer = setTimeout(() => {
      setExiting(true);
      // Warte auf fade-out Animation
      setTimeout(() => {
        if (onDismiss) onDismiss(id);
      }, 300);
    }, duration);

    return () => {
      cancelAnimationFrame(fadeInTimer);
      clearTimeout(dismissTimer);
    };
  }, [id, duration, onDismiss]);

  const className = [
    'toast',
    `toast-priority-${priority}`,
    `toast-style-${style}`,
    visible ? 'visible' : '',
    exiting ? 'exiting' : ''
  ].filter(Boolean).join(' ');

  return (
    <div
      className={className}
      style={{ '--toast-index': index }}
      onClick={() => {
        setExiting(true);
        setTimeout(() => onDismiss?.(id), 300);
      }}
    >
      {icon && <span className="toast-icon">{icon}</span>}
      <span className="toast-message">{message}</span>
    </div>
  );
});

export default Toast;
